export const environment = {
  firebase: {
    apiKey: "AIzaSyD6RtDhdmsO5z4whx_6n_dUfHWyvdTJLMk",
  authDomain: "besmart-app-development.firebaseapp.com",
  projectId: "besmart-app-development",
  storageBucket: "besmart-app-development.firebasestorage.app",
  messagingSenderId: "395988013654",
  appId: "1:395988013654:web:9a23aec204bff66813e1f7",
  measurementId: "G-REWQXQ41VT"
  },
  branding: {
    short_name: 'BeSmart',
    name: 'BeSmart Launchpad',
  },
  environment: 'development',
  apiUrl: 'http://localhost:5001/besmart-app-development/europe-west3/api',
};
